export default __webpack_public_path__ + "static/media/tunisian-flag.79a3c675.svg";